import { instance } from 'src/apis/index';

export interface ILoginForm {
  loginId: string;
  password: string;
}

export const apiLogin = {
  postLogin: (loginInfo: ILoginForm) =>
    instance.post('/login', loginInfo, {
      headers: {
        withcredentials: true,
      },
    }),
};
